import ActionAbstract from '../ActionAbstract';

class Tag extends ActionAbstract {

    static get ID() {
        return 'actions:library:tag';
    }

    run(state) {
        const tagMedias = this.getParam('tagMedias');

        // Add tags on multiple Media
        if (tagMedias) {
            // Cleanup vue observer if needed.
            let newDocMedias = []
            tagMedias.medias.forEach( (media) => {
                let docMedia = Object.assign( {}, media)
                newDocMedias.push(docMedia)
            })
            // post modifications to couchdb.
            this.deps.mainStore.lib.updateMedias(newDocMedias);

        } else {
            const method = this.getParam('method');
            const media = Object.assign({}, !method ? state.library.mediaPreview : this.getParam('media'));
            const tag = this.getParam('tag');
            const index = media.tags.indexOf(tag);

            // nothing to do if the tag is empty
            if (tag === '') return false;

            // update (only if needed)
            if (method === 'rm') {
                if (index === -1) return;
                media.tags.splice(index, 1);
            }
            else {
                if (index !== -1) return;
                media.tags.push(tag);
            }

            this.deps.mainStore.lib.updateMedia(media);

            return this.composeState(state, {
                library: {
                    mediaPreview: media
                }
            });
        }


    }

    runRemove(state) {

        let newMedia = Object.assign({}, state.library.mediaPreview),
            tagIndex = this.getParam('tagIndex');

        // sinon on sauv et reset newTag
        newMedia.tags.splice( tagIndex, 1 );

        this.deps.mainStore.lib.updateMedia(newMedia);

        return this.composeState(state, {
            library: {
                mediaPreview: newMedia
            }
        });

    }    

}

export default Tag;